import { RecentlyReadApi } from 'api/ApiHelper';
import { recentlyReadQueryKey } from 'queries/recentlyRead/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetRecentlyReadContentQuery = (contentId: number, enabled = false) =>
  useQuery({
    queryKey: recentlyReadQueryKey.recentlyRead(contentId),
    queryFn: async () => RecentlyReadApi.getContent(contentId),
    gcTime: 1000 * 60 * 60 * 24,
    enabled,
  });
